import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-counter',
  imports: [],
  templateUrl: './counter.html',
  styleUrl: './counter.scss',
  host: {
    class: 'w-full h-full block relative',
  },
})
export class Counter {
  value = input<number>(0);
  prefix = input<string | null>(null);
  suffix = input<string | null>(null);
  description = input<string>('');
  start = input<boolean>(false);
  dark = input<boolean>(false);
  fontSize = input<string>('text-5xl md:text-7xl');
  fontColor = input<string | null>(null);


  computedValue = computed(() => {
    // convert to number to strip trailing zeros, then to string
    const val = Number(this.value());
    const str = isNaN(val) ? '0' : val.toString();
    const arr = str.split('');
    
    // Find absolute index of the last actual digit
    let lastDigitIndex = -1;
    for (let i = arr.length - 1; i >= 0; i--) {
      if (/[0-9]/.test(arr[i])) {
        lastDigitIndex = i;
        break;
      }
    }

    return arr.map((char, index) => {
      const isDigit = /[0-9]/.test(char);
      return {
        char,
        isDigit,
        isLastDigit: index === lastDigitIndex,
        value: isDigit ? parseInt(char, 10) : 0
      };
    });
  });
}
